export const MONETIZE_CAROUSEL_HEADINGS = {
  merchandise: 'Shop My Merchandise',
  courses: 'Explore My Courses',
  experiences: 'Get a Personal Experience',
  nft: 'Check My NFTs',
  downloadables: 'Buy My Downloadables',
  video: 'Watch My Videos',
  article: 'Read My Articles',
  image: 'View My Photos',
  newsletter: 'Get My Newsletter',
  vip_offer: 'VIP Offers',
  portfolio: 'View My Portfolio',
  event_calendar: 'Upcoming Events',
  NOT_FOUND_PRODUCT: 'No items to display',
  SEE_ALL: 'See All',
  SEE_LESS: 'See Less',
  EXTERNAL: 'External'
};

export const STORE_CAROUSEL_MAP = {
  merchandise: 'MERCHANDISE',
  courses: 'COURSE',
  experiences: 'EXPERIENCE',
  nft: 'NFT',
  downloadables: 'DOWNLOADABLES',
};

export interface MonetizeCarouselItem {
  title: string;
  image: string;
  pk: string;
  sk: string;
  price?: number;
  isExternal?: boolean;
}